export const enumKYCStatus = (() => {
    let APPROVED = 'APPROVED'
        , NO = 'NO'
        , REJECTED = 'REJECTED'
        , PENDING = 'PENDING'
        , VERIFYING = 'VERIFYING'
        ;
    return {APPROVED, NO, REJECTED, PENDING, VERIFYING};
})();
/**
 * Get UI Config at once
 *
 * @since 2024.12.4
 */
export const getPIIKYCDepositUIConfig = ({depositBVStatusCheck, depositPIIStatus, depositKYCStatusCheck, depositKYCStatus}) => {
    let b1 = depositBVStatusCheck
        , b2 = depositPIIStatus
        , b3 = depositKYCStatusCheck
        , _ = typeof depositKYCStatus==='string' ? depositKYCStatus.toUpperCase() : '';

    let isA = b1 && b2 && b3;
    let isB = b1 && b2 && !b3;
    let isC = b1 && !b2 && b3;
    let isD = b1 && !b2 && !b3;
    let isE = !b1 && b2 && b3;
    let isF = !b1 && b2 && !b3;
    let isG = !b1 && !b2 && b3;
    let isH = !b1 && !b2 && !b3;

    let isShowMasterLock, isShowLockContent, isShowReminder;
    if (isA) {
        isShowMasterLock = _!=enumKYCStatus.APPROVED
        isShowLockContent = isShowMasterLock
        isShowReminder = false
    } else if (isB) {
        isShowMasterLock = false
        isShowLockContent = isShowMasterLock
        isShowReminder = _!=enumKYCStatus.APPROVED && _!=enumKYCStatus.VERIFYING
    } else if (isC) {
        isShowMasterLock = true
        isShowLockContent = isShowMasterLock
        isShowReminder = false
    } else if (isD) {
        isShowMasterLock = true
        isShowLockContent = isShowMasterLock
        isShowReminder = false
    } else if (isE) {
        isShowMasterLock = _!=enumKYCStatus.APPROVED
        isShowLockContent = isShowMasterLock
        isShowReminder = false
    } else if (isF) {
        isShowMasterLock = false
        isShowLockContent = isShowMasterLock
        isShowReminder = _!=enumKYCStatus.APPROVED && _!=enumKYCStatus.VERIFYING
    } else if (isG) {
        isShowMasterLock = _!=enumKYCStatus.APPROVED
        isShowLockContent = isShowMasterLock
        isShowReminder = _==enumKYCStatus.APPROVED
    } else if (isH) {
        isShowMasterLock = false
        isShowLockContent = isShowMasterLock
        isShowReminder = true
    }

    return {isShowMasterLock, isShowLockContent, isShowReminder}
};
